import React, { useState } from "react";
import "./App.scss";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { sendFormData } from "./utils/bx24";

function App() {
  const [isFilled, setIsFilled] = useState(false);
  const [phone, setPhone] = useState("+380");
  const [isError, setIsError] = useState(false);
  const [errorText, setErrorText] = useState("");
  const [name, setName] = useState("");
  const [devicesCount, setDevicesCount] = useState("");
  const [devicesCapacity, setDevicesCapacity] = useState("");
  const [comment, setComment] = useState("");
  const [senderAddress, setSenderAddress] = useState("");

  const submitFormHandle = async (event) => {
    event.preventDefault();
    setIsError(false);

    if (phone.trim().slice(0, 4) !== "+380") {
      setErrorText("*Номер телефону повинен починатися з +380");
      setIsError(true);
      return;
    }

    if (phone.length !== 13) {
      setErrorText("*Неправильний номер телефону");
      setIsError(true);
      return;
    }

    const formData = {
      phone,
      name,
      devicesCount,
      devicesCapacity,
      senderAddress,
      comment,
    };

    setIsFilled(true);

    await sendFormData(formData);
  };

  return (
    <div className="App">
      <div className="main">
        <h1 className="title">
          ЗБИРАЄМО ВИКОРИСТАНІ ОДНОРАЗКИ, ЩОБ ВИГОТОВИТИ POWER BANK ДЛЯ ЗСУ
        </h1>
        <div className="bonus">
          {isFilled ? (
            <>
              <div className="divider"></div>
              <p className="message">
                Дякуємо. Ваша заявка буде оброблена протягом 24-ох годин.🐵❤️
              </p>
              <div className="divider"></div>
            </>
          ) : (
            <>
              <div className="bonus_instruction">
                <div>
                  <p className="bonus_instruction_item">
                    Компанія Vandal Vape уже виготовила понад 300 павербанків із
                    використаних одноразових подсистем і передала
                    військовослужбовцям для їх потреб.
                    <br />
                    <br />
                    Так як для виготовлення одного павербанка потрібно від 28 до
                    38 відібраних та перевірених акумуляторів однакової ємності,
                    нам необхідно постійно поповнювати кількість використаних
                    одноразок для переробки.
                    <br />
                    <br />
                    Тому ми пропонуємо вам, наші любі клієнти, трохи нам
                    допомогти. Надішліть нам свої використані одноразки - і ми
                    зробимо з них павербанки та надішлемо військовим.
                    <br />
                    <br />
                    Якщо у вас назбиралось 20 і більше одноразок - їх доставку
                    до наших майстрів оплатимо ми, а також активуємо для вас
                    кешбек 10% з наступного замовлення і до наступної покупки
                    додамо ексклюзивний стікерпак.
                    <br />
                    <br />
                    Заповніть форму нижче, щоб ми могли з вами зв’язатись.
                  </p>
                </div>
              </div>

              <div className="form_wrap">
                <form
                  className="form_form"
                  onSubmit={(e) => submitFormHandle(e)}
                  method="post"
                  action="https://www.corezoid.com/api/2/json/public/1175510/23ea0d5e99cb6787061d5dc5da5eed681c3d5360"
                >
                  <div className="form">
                    <div className="form_input">
                      {isError && <p className="phoneError">{errorText}</p>}
                      <TextField
                        required
                        id="outlined-basic"
                        label="НОМЕР ТЕЛЕФОНУ"
                        variant="outlined"
                        value={phone}
                        className="input_field"
                        onChange={(e) => {
                          setPhone(e.target.value);
                          setIsError(false);
                        }}
                        name="phone"
                      />
                    </div>

                    <div className="form_input">
                      <TextField
                        required
                        id="outlined-basic"
                        label="ІМ’Я ТА ПРІЗВИЩЕ"
                        variant="outlined"
                        className="input_field"
                        name="link"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </div>

                    <div className="form_input">
                      <TextField
                        required
                        id="outlined-basic"
                        label="КІЛЬКІСТЬ ОДНОРАЗОК, ЯКУ ВИ МОЖЕТЕ ВІДПРАВИТИ"
                        variant="outlined"
                        className="input_field"
                        name="link"
                        value={devicesCount}
                        onChange={(e) => setDevicesCount(e.target.value)}
                      />
                    </div>

                    <div className="form_input">
                      <TextField
                        required
                        id="outlined-basic"
                        label="АДРЕСА I НОМЕР ВІДДІЛЕННЯ НОВОЇ ПОШТИ, З ЯКОГО БУДЕ ВІДПРАВКА"
                        variant="outlined"
                        className="input_field"
                        name="link"
                        value={senderAddress}
                        onChange={(e) => setSenderAddress(e.target.value)}
                      />
                    </div>

                    <div className="form_input">
                      <TextField
                        required
                        id="outlined-basic"
                        label="ЄМНІСТЬ ОДНОРАЗОК"
                        variant="outlined"
                        className="input_field"
                        name="link"
                        value={devicesCapacity}
                        onChange={(e) => setDevicesCapacity(e.target.value)}
                      />
                    </div>

                    <div className="form_input">
                      <TextField
                        id="outlined-basic"
                        label="КОМЕНТАР "
                        variant="outlined"
                        className="input_field"
                        name="link"
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                      />
                    </div>
                  </div>

                  <p>
                    Якщо ви раніше не спілкувались з нашою компанією в чаті -
                    перейдіть, будь ласка за посиланням на{" "}
                    <a
                      href="https://t.me/VandalVapeBot"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Telegram
                    </a>{" "}
                    або{" "}
                    <a
                      href="https://vandalvape.com.ua/r/viber"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Viber
                    </a>{" "}
                    і напишіть свій номер телефону, починаючи з +380 , щоб ми
                    могли вийти з вами на зв'язок. Дякуємо😊
                  </p>

                  <div className="submit">
                    <Button
                      variant="contained"
                      className="form_button"
                      type="submit"
                      color="warning"
                    >
                      Відправити
                    </Button>
                  </div>
                </form>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default App;
